import React from 'react';

class StrategyBuilderErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(" [StrategyBuilder] Error Boundary caught error:", error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center h-screen bg-bg-3 dark:bg-bg-1">
          <div className="max-w-2xl p-8 bg-white dark:bg-bg-2 rounded-lg shadow-xl">
            <h1 className="text-2xl font-bold text-loss mb-4">⚠️ Strategy Builder Error</h1>
            <div className="mb-4">
              <h2 className="font-bold text-fg-1 mb-2">Error:</h2>
              <pre className="p-4 bg-loss/10 text-loss rounded overflow-auto max-h-40 text-sm">
                {this.state.error && this.state.error.toString()}
              </pre>
            </div>
            <div className="mb-4">
              <h2 className="font-bold text-fg-1 mb-2">Stack Trace:</h2>
              <pre className="p-4 bg-bg-3 dark:bg-bg-1 text-fg-1 rounded overflow-auto max-h-60 text-xs">
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </div>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-accent hover:opacity-90 text-white rounded-lg font-medium transition-colors"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default StrategyBuilderErrorBoundary;
